import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetCart } from '../../../url-handling'

export const CartUrl: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <strong>
      <a href={urlResolverGetCart(globalConfig)}>
        <FormattedMessage id="menubar.link.label.cart" />
      </a>
    </strong>
  )
}
